// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3PcwR","colMin":"styles_colMin__3oc4B","colCheckbox":"styles_colCheckbox__B9rt4"};